import { useTranslation } from "react-i18next";
import { IconFire, IconGift, IconUserImages, IconUserChristmasImages } from "../elements/Icon";
import { IconMedal } from "../elements/Icon2";
import { checkChristmas } from "../../hooks/useCheckChristmas";
import { isDev, isProd } from "../../config";
import { useRef, useEffect } from "react";
import { AVATAR } from "../../config.js"

export const UserModalPage = ({ userModal, setUserModal }) => {
    const { t } = useTranslation();
    const modalRef = useRef(null);

    const basePath = isDev
        ? "https://sandbox.mathmindsgame.com:3080"
        : isProd
            ? "https://mathmindsgame.com:3080"
            : "http://127.0.0.1:3000";

    const formatDate = (timestamp) => {
        if (!timestamp) return "-";
        const d = new Date(timestamp * 1000);
        let date = d.toLocaleDateString("en-GB");
        return date.replaceAll("/", ".")
    };
    const lang = localStorage.getItem('i18nextLng') || 'en'
    const regionNames = new Intl.DisplayNames([lang], { type: 'region' });


    const onClose = () => {
        setUserModal(null);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            onClick={onClose}
            className="absolute inset-0 z-[100000] bg-black/30 flex justify-center items-center"
        >
            <div
                ref={modalRef}
                onClick={(e) => e.stopPropagation()}
                style={{ backgroundImage: "url('/backGrounds/userModal.svg')" }}
                className="
                    relative
                    flex flex-col
                    w-[336px] sm:w-[318px] md:w-[372px] xl:w-[450px] lg:w-[427px]
                    h-[211px] sm:h-[194px] md:h-[259px] xl:h-[335px] lg:h-[297px]
                    rounded-[20px]
                    border-[4px] border-[#7B4BC4]
                    bg-cover bg-center
                    
                    "
            >
                {/* TOP */}
                <div className="flex items-center justify-between 
                xl:p-[18px] lg:p-[16px] md:p-[14px] p-[12px]">

                    {/* LEFT */}
                    <div className="flex items-center gap-4">

                        {/* avatar */}
                        <div
                            className="
                                        flex-shrink-0
                                        xl:w-[127px] lg:w-[90px] md:w-[78px] sm:w-[64px] w-[64px]
                                        xl:h-[127px] lg:h-[90px] md:h-[78px] sm:h-[64px] h-[64px]
                                        rounded-full overflow-hidden
                                        bg-[#ACC587] border border-[#7743BA]
                                        flex items-center justify-center"
                        >


                            {userModal.avatar.startsWith("avatar") ? (
                                checkChristmas() ? (
                                    <IconUserChristmasImages user={userModal.avatar} />
                                ) : (
                                    <IconUserImages user={userModal.avatar} />
                                )
                            ) : (
                                <img
                                    src={`${AVATAR}${userModal.avatar}.png`}
                                    alt="avatar"
                                    className="w-full h-full object-cover"
                                />
                            )}
                        </div>

                        {/* nickname + country */}
                        <div className="flex flex-col">

                            <p className="xl:text-[24px] lg:text-[20px] md:text-[16px] text-[16px] text-[#4B96C9] font-bold xl:pb-[15px] lg:pb-[15px] md:pb-[6px] pb-[8px]">
                                {userModal?.nickname}
                            </p>

                            <div className="flex items-center gap-[4px]">

                                <div
                                    className="
                                                xl:w-[18px] lg:w-[18px] md:w-[21px] w-[18px]
                                                xl:h-[12px] lg:h-[12px] md:h-[14px] h-[12px]
                                                border bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url(${basePath}/images/flags/${userModal?.cc}.svg)`
                                    }}
                                />

                                <span className="xl:text-[12px] lg:text-[12px] md:text-[12px] text-[10px] truncate">
                                    {regionNames.of(userModal?.cc || "AM")}
                                </span>

                            </div>

                        </div>

                    </div>

                    {/* RIGHT */}
                    <div className="flex flex-col items-center
                    xl:pr-[18px] lg:pr-[33px] md:pr-[24px] pr-[20px]
                    xl:pt-[18px] lg:pt-[20px] md:pt-[10px] pt-[9px]">

                        <IconMedal className="
                        xl:w-[38px] lg:w-[33.78px] md:w-[29.56px] w-[25.33px]
                        xl:w-[43.67px] lg:w-[38.82px] md:w-[33.97px] w-[29.12px]" />

                        <p className={`${userModal?.position <= 3 ? "relative xl:-top-[44px] lg:-top-[38px] md:-top-[35px] -top-[31px] text-[#FFF]" : "text-[#4B96C9]"} xl:text-[20px] lg:text-[16px] md:text-[16px] text-[16px]  font-bold`}>
                            {userModal?.position}
                        </p>

                    </div>

                </div>

                <div className="border-t border-[#ACC587] "></div>

                {/* stats */}
                <div className="xl:px-[21px] lg:xl:px-[24px] md:px-[14px] px-[15px] flex-1">
                    <table className="w-full h-full xl:text-[20px] lg:text-[16px] md:text-[14px] text-[12px] border-collapse font-bold">
                        <tbody className="h-full">
                            <tr className="h-1/3">
                                <td className="xl:w-[130px] lg:w-[120px] md:w-[110px] w-[95px] xl:pr-[24px] lg:pr-[29px] md:pr-[25px] pr-[27px] text-[#7B4BC4] text-right">Today</td>

                                <td className="text-left text-[#4B96C9]  border-[#F3F4D1] pr-3">
                                    {userModal?.dp}
                                </td>

                                <td className="text-right text-[#4B96C9]">
                                    <div className="flex items-center justify-end xl:gap-[3px] lg:gap-[6px] md:gap-[4px] gap-[3px]">
                                        <IconFire className="xl:h-[27px] lg:h-[27px] md:h-[23px] h-[16px]" />
                                        <span>{userModal?.strike}</span>
                                    </div>
                                </td>

                                <td className="text-right text-[#4B96C9]">
                                    <div className="flex items-center justify-end xl:gap-[3px] lg:gap-[6px] md:gap-[4px] gap-[3px]
                                    xl:pl-[14px] lg:pl-[12px] md:pl-[10px] pl-[8px]">
                                        <IconGift className="xl:h-[27px] lg:h-[27px] md:h-[23px] h-[16px]" />
                                        <span>{userModal?.gift}</span>
                                    </div>
                                </td>
                            </tr>

                            {/* line */}
                            <tr>
                                <td colSpan={2}>
                                    <div className="border-b border-[#F3F4D1] w-[95%]"></div>
                                </td>

                                <td colSpan={2}>
                                    <div className="border-b border-[#F3F4D1]"></div>
                                </td>
                            </tr>

                            <tr className="h-1/3">
                                <td className="xl:w-[130px] lg:w-[120px] md:w-[110px] w-[95px] xl:pr-[24px] lg:pr-[29px] md:pr-[25px] pr-[27px] text-[#7B4BC4] text-right ">All</td>

                                <td className="text-left text-[#4B96C9] border-[#F3F4D1] pr-3">
                                    {userModal?.tp}
                                </td>

                                <td colSpan={2}></td>
                            </tr>

                            <tr>
                                <td colSpan={2}>
                                    <div className="border-b border-[#F3F4D1] w-[95%]"></div>
                                </td>

                                <td colSpan={2}></td>
                            </tr>

                            <tr className="h-1/3">
                                <td className="xl:w-[130px] lg:w-[120px] md:w-[110px] w-[95px] xl:pr-[24px] lg:pr-[29px] md:pr-[25px] pr-[27px] text-[#7B4BC4] text-right">Last Active</td>
                                <td className="text-left text-[#4B96C9]">
                                    {formatDate(userModal?.active)}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

